import type { JobLocationInfo, ResultsListProps } from "~/types";
import ResultItem from "./ResultItem";
import ZeroFound from "./ZeroFound";
import { formatPayment } from "~/utils/formatSalary";

const formatLocation = ({
  location_city,
  prefectures,
}: JobLocationInfo): string => {
  return location_city === null
    ? prefectures.name
    : `${prefectures.name}${location_city}`;
};

export const ResultsList = ({
  pagingJobs,
  masters,
  currentEnvironment,
}: ResultsListProps) => {
  return pagingJobs.length > 0 ? (
    pagingJobs.map((pagingJob) => (
      <ResultItem
        key={pagingJob.id}
        company={
          pagingJob.is_company_not_public
            ? "企業名非公開"
            : pagingJob.company_name
        }
        title={pagingJob.title}
        payment={formatPayment({
          salary_min: pagingJob.salary_min,
          salary_max: pagingJob.salary_max,
          salary_display_type: pagingJob.salary_display_type,
        })}
        location={formatLocation(pagingJob)}
        holiday={pagingJob.holiday_schedule ?? ""}
        linkUrl={
          currentEnvironment === "production"
            ? `/detail/${pagingJob.job_key}.html`
            : `https://preview.public.fjob-kyujin.com/detail/${pagingJob.job_key}.html`
        }
      >
        <li>{pagingJob.occupation_types.name}</li>
        {pagingJob.job_service_types.map((jobServiceType) => (
          <li key={jobServiceType.service_types.id}>
            {jobServiceType.service_types.name}
          </li>
        ))}
      </ResultItem>
    ))
  ) : (
    <ZeroFound masters={masters} />
  );
};
